<script>
import { mapActions, mapGetters } from 'vuex'
import LABELS from '@/constants/labels'
import { templateList, backgroundTable } from '@/constants/data'

export default {
  name: 'selectTemplate',
  data() {
    return {
      data: null,
      currentTabData: null,
      currentSelect: null,
    }
  },
  computed: {
    ...mapGetters('settings', ['getOrientation', 'getTemplate']),
    mappingLabels() {
      return LABELS
    },
  },
  methods: {
    ...mapActions('settings', ['setTemplate', 'setModules', 'saveToStorage']),
    handleChangeTab(item) {
      this.currentTabData = item
    },
    handleSelect(id) {
      const find = this.currentTabData.templates.find(item => item.id === id)
      if (find) {
        this.currentSelect = {
          tabId: this.currentTabData.id,
          template: find,
        }
      }
    },
    handleShowPopup({ thumbnail, name, description }) {
      this.$refs.shapeInfoModal.show({
        src: thumbnail,
        name,
        description,
      })
    },
    handleNextStep() {
      this.setTemplate({
        tabId: this.currentSelect.tabId,
        templateId: this.currentSelect.template.id,
      })
      this.setModules({
        data: {
          background:
            backgroundTable.find(
              bg => bg.id === this.currentSelect.template.bgId
            ) || '',
          avatars: this.currentSelect.template.avatars,
          stamps: this.currentSelect.template.stamps,
          texts: this.currentSelect.template.texts,
        },
      })
      this.saveToStorage()
      this.$router.push({ name: 'preview' })
    },
    setDefaultData() {
      this.currentSelect = {
        tabId: this.currentTabData.id,
        template: this.currentTabData.templates[0],
      }
    },
  },
  created() {
    if (this.getOrientation) {
      this.data = templateList[this.getOrientation]
    }
    const idx = this.data.findIndex(item => item.id === this.getTemplate.tabId)
    if (idx === -1) {
      this.currentTabData = this.data[0]
      this.setDefaultData()
    } else {
      this.currentTabData = this.data[idx]
      const find = this.currentTabData.templates.find(
        item => item.id === this.getTemplate.templateId
      )
      if (find) {
        this.currentSelect = {
          tabId: this.getTemplate.tabId,
          template: find,
        }
      } else {
        this.setDefaultData()
      }
    }
  },
}
</script>

<template>
  <div>
    <s-title>{{ mappingLabels.templateTitle }}</s-title>
    <div class="select-shape">
      <div class="select-shape__body">
        <s-tab
          ref="tab"
          :tabs="data"
          :defaultTab="currentSelect.tabId"
          @change-tab="handleChangeTab"
          :id="'shape-tabs'"
          class="tab"
        >
          <template>
            <div class="select-shape__container" ref="tab-content">
              <div
                class="select-shape__container-icon"
                v-for="(item, idx) of currentTabData.templates"
                :key="idx"
              >
                <div class="select-shape__container-content">
                  <div
                    class="select-shape__container-btnModal"
                    @click="handleShowPopup(item)"
                  >
                    <x-icon-zoom />
                  </div>
                  <div
                    class="select-shape__container-img"
                    :class="{ active: currentSelect.template.id === item.id }"
                    @click="handleSelect(item.id)"
                  >
                    <img :src="item.thumbnail" :alt="item.name" />
                  </div>
                </div>
                <div class="select-shape__container-name">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </template>
        </s-tab>
      </div>
      <s-navigate-bar
        class="navigate-bar-fixed"
        @leftClick="$router.push({ name: 'select-layout' })"
        @rightClick="handleNextStep"
        >{{ mappingLabels.nextText }}</s-navigate-bar
      >
      <s-modal-shapeinfo
        ref="shapeInfoModal"
        :isLandscape="getOrientation === 'landscape'"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'selectTemplate.scss';
</style>
